import Vue from 'vue';
import App from './App.vue';
import './services/cartxMonitor';
import router from './router';
import store from './store';
import * as Echart from 'echarts';
import '@/plugins';
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';
// add new rewrite element-ui scoped By V.C
import './assets/css/reset.scss';
import './assets/css/file-scope-upgrade.scss';
import './assets/font/index.css';
import { LogJsError } from './services/cartxLog';
import './services/longtask';
import { monitor, MonitorEvent } from './services/monitor';
import GlobalTrackingPlugin from './plugins/globalTracking';
import locale from 'element-ui/lib/locale';
import elementZhCN from 'element-ui/lib/locale/lang/zh-CN';
import elementEn from 'element-ui/lib/locale/lang/en';
import elementVi from 'element-ui/lib/locale/lang/vi';
import { bootstrapUiLocaleMeta, getUiLocale, persistUiLocale } from '@/i18n/locale';
import { bootstrapUiMessages, tx } from '@/i18n/pack';
import { helpDoc } from '@/i18n/helpDocs';
import { toastFailMessage } from '@/i18n/failMessage';

// 注册全局点击事件监控插件
Vue.use(GlobalTrackingPlugin);

const elementLocaleMap = {
  'zh-CN': elementZhCN,
  'en-US': elementEn,
  'vi-VN': elementVi,
};

const urlLang = new URLSearchParams(window.location.search).get('lang');
if (urlLang) {
  persistUiLocale(urlLang);
} else {
  persistUiLocale(getUiLocale());
}

bootstrapUiLocaleMeta()
  .then(() => {
    persistUiLocale(getUiLocale());
    return bootstrapUiMessages();
  })
  .finally(() => {
  persistUiLocale(getUiLocale());
  const uiLocale = getUiLocale() as keyof typeof elementLocaleMap;
  locale.use(elementLocaleMap[uiLocale] || elementZhCN);
  Vue.prototype.$tx = (
    key: string,
    fallback: string,
    vars?: Record<string, string | number>
  ) => tx(null, key, fallback, vars);
  Vue.prototype.$helpDoc = helpDoc;
  Vue.prototype.$failMsg = toastFailMessage;

  router.afterEach((to, from) => {
    monitor({
      event: MonitorEvent.PageView,
      data: {
        path: to.fullPath,
        from: from.fullPath,
      }
    });
  });

  Vue.config.errorHandler = (err:Error, vm: Vue, info:string) => {
    console.log('err', err);
    if (err.stack || err.message) {
      LogJsError({
        em:err?.message || `${err?.toString?.()}`,
        es:err?.stack,
        type:'vueerror',
      });
    }
  }
  Vue.config.productionTip = false;
  Vue.prototype.$echarts = Echart;
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
  console.log('version: ' + process.env.VUE_APP_VERSION);
});
